import { render, staticRenderFns } from "./productcategorydetails.vue?vue&type=template&id=67188e4c&scoped=true&"
import script from "./productcategorydetails.vue?vue&type=script&lang=js&"
export * from "./productcategorydetails.vue?vue&type=script&lang=js&"
import style0 from "./productcategorydetails.vue?vue&type=style&index=0&id=67188e4c&scoped=true&lang=css&"
import style1 from "./productcategorydetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67188e4c",
  null
  
)

export default component.exports